'use strict';

module.exports = angular.module('superdostavka.mainCtrl', [])
.controller('MainCtrl', ['$scope', '$rootScope', '$http', '$controller', '$timeout', 'posManager', 'modal', 'userManager', 'city', 'metrics', 'giftManager',
    function($scope, $rootScope, $http, $controller, $timeout, posManager, modal, userManager, city, metrics, giftManager) {
    $controller('BaseCtrl', {$scope: $scope})

    $scope.userManager = userManager;

    $scope.posManager = posManager;
    $scope.modalPos = {};
    $scope.showPreloadImage = true;
    $scope.navSticked = false;
    $scope.city = city;
    $scope.metrics = metrics;
    $scope.windowLoad = false;

    $scope.giftManager = giftManager;

    if(!$scope.giftManager.config)
        $scope.giftManager.init();

    $scope.$watch('$viewContentLoaded', function(){
        $scope.windowLoad = true;
    });

    var initialized = false;
    var init = function() {
      // Конструктор и ng-init шаблона вызывают один запуск, в том числе в подменах из БД.
      if (initialized)
          return;
      initialized = true;
      $scope.posManager.init();
      $scope.userManager.getUser();
      $scope.config = $scope.getConfig();
    }

    $scope.init = init;
    init();



    $scope.modChanged = function(id)
    {
      metrics.metricsEvent('modification_changed', 'modification', 'change', {'label': 'Changed modification', 'value': id});
    }

    $scope.ignoreNotWorking = function()
    {
        $http.get('/rapi/ignoreNotWorking').success(function() {});
    }

    // isMobile() вызывается при каждой проверке изменений (ng-if="!isMobile()"). Пока ядро меняет DOM,
    // чтение window.innerWidth заставляет браузер заново считать вёрстку. Ширина окна запоминается
    // и обновляется при изменении размера окна (в том числе при повороте телефона).
    var viewportWidth = window.innerWidth;
    window.addEventListener('resize', function() {
        viewportWidth = window.innerWidth;
    });

    $scope.isMobile = function(mobileWidth = 950)
    {
        return viewportWidth <= mobileWidth;
    }

    $scope.addItem = function(id, quantity)
    {
      posManager.addItem(id, quantity);

      $scope.addedPos = posManager.getActiveMod(id);

      if (quantity > 0) {
        $scope.modal.show('showAddedBubble');

        $timeout(function() {
          $scope.modal.hide('showAddedBubble');
        }, 2000);
      }
    }
}]);
